import React, { Component } from "react";

import {
  CButton,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CListGroup,
  CListGroupItem
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";
import { getShareRoles } from "../../helpers/doc";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class PermissionFileModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRoles: [],
      roles: [],
      loading: false,
      loadingRoles: true
    };
  }

  componentDidMount() {
    axios
      .get(`${URL.api}content/doc/singleView/${this.props.selected.id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        getShareRoles(
          this.props.general.active_roles,
          this.props.user.token
        ).then(
          roles => {
            let selectedRole;

            selectedRole = resp.data.data.doc_role.map(
              docRole => docRole.role_id
            );

            this.setState({
              roles: roles.map(role => ({
                ...role,
                room_id: this.props.selected.room_id
              })),
              selectedRoles: selectedRole,
              loadingRoles: false
            });
          },
          error => {
            this.error("Erro ao encontrar perfis");
          }
        );
      });
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  editRoles() {
    this.setState({ loading: true });

    let { roles } = this.state;

    roles = roles.filter(item =>
      this.state.selectedRoles.includes(item.role_id)
    );

    axios
      .post(
        `${URL.api}content/doc/update/${this.props.selected.id}`,
        { role: roles },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.insertNotice();
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  }

  insertNotice() {
    let { roles } = this.state;

    roles = roles.filter(item =>
      this.state.selectedRoles.includes(item.role_id)
    );

    const obj = {
      user_id: this.props.user.user.id,
      title: "Um arquivo teve suas permissões alteradas",
      type: "notification",
      docs: [this.props.selected.id],
      roles
    };

    axios
      .post(`${URL.api}communication/notice/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({ loading: false });
          this.props.onClose();
        },
        error => {
          this.error(error.response.statusText);
          this.setState({ loading: false });
        }
      );
  }

  render() {
    return (
      <CModal
        size="md"
        centered
        show
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>Permissões do arquivo</CModalHeader>
        <CModalBody className="p-0">
          {this.state.loadingRoles ? (
            <div className="p-4 d-flex justify-content-center">
              <CSpinner size="sm" color="light" />
            </div>
          ) : (
            <CListGroup style={{ borderRadius: 0 }}>
              {this.state.roles.map(role => (
                <CListGroupItem
                  action
                  className="cursor"
                  active={this.state.selectedRoles.includes(role.role_id)}
                  onClick={() =>
                    this.setState(state => ({
                      selectedRoles: state.selectedRoles.includes(role.role_id)
                        ? state.selectedRoles.filter(
                            item => item !== role.role_id
                          )
                        : [...state.selectedRoles, role.role_id]
                    }))
                  }
                >
                  <h5 className="d-flex w-100">{role.role_name}</h5>
                  <div className="mb-1">
                    Compartilhar com os usuários do perfil {role.role_name}
                  </div>
                </CListGroupItem>
              ))}
              <CListGroupItem
                action
                className="cursor"
                active={this.state.selectedRoles.length === 0}
                onClick={() => this.setState({ selectedRoles: [] })}
              >
                <h5 className="d-flex w-100">Apenas eu</h5>
                <div className="mb-1">
                  Não compartilhar com nenhum outro usuário
                </div>
              </CListGroupItem>
            </CListGroup>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            onClick={() => this.editRoles()}
          >
            <span className={this.state.loading ? "invisible" : ""}>
              Salvar
            </span>
            {this.state.loading && (
              <CSpinner
                size="sm"
                color="white"
                style={{ position: "absolute" }}
              />
            )}
          </CButton>{" "}
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionFileModal);
